import getBody from './getBody';

const EMAIL_ADDRESS_REGEX = /<([\w\S]+@[\w\S]+)>/gi;

export default async function getAllEmailAddressesFromThread(): Promise<
  Array<string>
> {
  const text = await getBody('Text');
  const matches = Array.from(text.matchAll(EMAIL_ADDRESS_REGEX));

  return matches.map((match) => match?.[1] ?? '');
}
